export const HealthCareInterests = [
  "Dermatology",
  "Bone Health",
  "Diabetic Foot Health",
  "Specialty",
  "Nephropathy",
];
